import { IconScaleStars } from '@presentation/components';
import { PLACEHOLDER_IMAGE_USER } from '@presentation/constants';
import type { FC } from 'react';
import { useMemo } from 'react';
import * as Styled from '../../styled';
import type { FooterProps } from './types';

export const Footer: FC<FooterProps> = (props) => {
  const { name, personName, image, onClick, rating } = props;

  const showPersonName = useMemo((): boolean => {
    if (!!name && !!rating?.amount) return false;
    return !!personName;
  }, [name, personName, rating?.amount]);

  return (
    <Styled.FooterContainer onClick={onClick}>
      <Styled.FooterProfileImage src={image ?? PLACEHOLDER_IMAGE_USER} />
      <Styled.FooterTextContainer>
        {!!name && <Styled.FooterTitle>{name}</Styled.FooterTitle>}
        {showPersonName && <Styled.FooterSubtitle>{personName}</Styled.FooterSubtitle>}
        {!!rating?.amount && (
          <Styled.ReviewWrapper>
            <IconScaleStars amount={rating.average} />
            <Styled.ReviewText>({rating.amount})</Styled.ReviewText>
          </Styled.ReviewWrapper>
        )}
      </Styled.FooterTextContainer>
    </Styled.FooterContainer>
  );
};
